<template>
  <div class="account-page address-form" >
    <form v-if="form">
      <AccountPanel title="Adres dostawy">
        <div class="col-12">
          <div class="row" v-if="form">
            <div class="col-6">
              <div class="form-group">
                <label for="forname">Imię</label>
                <input id="forname" name="forname" class="form-control" type="text" required v-model="form.forname.value"
                       @blur="validateField($event, form.forname)" />
                <span class="invalid-feedback" v-if="form.forname.errors.required">Pole nie może być puste</span>
              </div>
            </div>
            <div class="col-6">
              <div class="form-group">
                <label for="surname">Nazwisko</label>
                <input id="surname" name="surname" class="form-control" type="text" required v-model="form.surname.value"
                       @blur="validateField($event, form.surname)" />
                <span class="invalid-feedback" v-if="form.surname.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-9">
              <div class="form-group">
                <label for="street">Ulica</label>
                <input id="street" name="street" class="form-control" type="text" required v-model="form.street.value"
                       @blur="validateField($event, form.street)" />
                <span class="invalid-feedback" v-if="form.street.errors.required">Pole nie może być puste</span>
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label for="flat">Numer domu</label>
                <input id="flat" name="flat" class="form-control" type="text"  v-model="form.flat.value" />
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-5">
              <div class="form-group">
                <label for="postcode">Kod pocztowy</label>
                <input id="postcode" name="postcode" class="form-control" type="text" required v-model="form.postcode.value"
                       @blur="validateField($event, form.postcode)" />
                <span class="invalid-feedback" v-if="form.postcode.errors.required">Pole nie może być puste</span>
              </div>
            </div>
            <div class="col-7">
              <div class="form-group">
                <label for="city">Miasto</label>
                <input id="city" name="city" class="form-control" type="text" required v-model="form.city.value"
                       @blur="validateField($event, form.city)" />
                <span class="invalid-feedback" v-if="form.city.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12">
              <div class="form-group">
                <label for="country">Kraj</label>
                <select v-model="form.country.value"  id="country" name="country" class="form-control">
                  <option v-for="country in company.countries" :value="country.id">{{ country.name }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-6">
              <div class="form-group">
                <label for="phone">Telefon</label>
                <input id="phone" name="phone" class="form-control" type="text" required v-model="form.phone.value"
                       @blur="validateField($event, form.phone)" />
                <span class="invalid-feedback" v-if="form.phone.errors.required">Pole nie może być puste</span>
              </div>
            </div>
          </div>
          <div class="row" v-if="form">
            <div class="col-12 contact-prefer">
              <div class="contact_button">
                <button class="btn btn-primary" :disabled="!submittable" @click="submit" right>Zapisz adres</button>
              </div>
            </div>
          </div>
        </div>
      </AccountPanel>
    </form>
  </div>
</template>


<script type="text/babel">

  import Form from "../../../form/src/Form";
  import AccountPanel from './AccountPanel.vue'

  import { mapState } from 'vuex';

  export default{
    components: {AccountPanel},
    data () {
      return {
        form: Form.build({
            forname: '',
            surname: '',
            street: '',
            flat: '',
            postcode: '',
            city: '',
            phone: '',
            country: 1
        }),
        submitted: false,
        progress: false
      }
    },
    computed: {
      submittable () {
        return !this.progress && !this.submitted
      },
      ...mapState({
        company: state => state.company,
      }),
    },
    methods: {
      ...Form.methods(),
      async submit (evt) {
        let data = this.validateForm(evt, this.form);
        if(data) {
          this.progress = true;
          this.submitted = true;
          let countryId = data.country;
          data.country = {id: countryId};
          await this.$store.dispatch('user/addAddress', data);
          this.progress = false;
          this.submitted = false;
          this.$router.replace({name: 'addresses'});
        }

      }
    },
    beforeMount() {
      if (!this.$store.state.user.authorizedUser) {
        this.$router.replace({name: 'mainPage'});
      }

      this.$store.dispatch('company/countries');
    },


  }
</script>



// WEBPACK FOOTER //
// src/components/account/src/account/AddressForm.vue